/**
* Base Controller
**/
require("filter/filterModule");



// WEBPACK FOOTER //
// ./js/filter/filter.js